module.exports = __webpack_public_path__ + "static/img/Planificaciones_1_banner planif@4x.5204b60b.png";